import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const BorrarRecurso = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.del(`/recursos/${params}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        borrarRecursoMutation: mutation.mutate,
    };
}